import React, { Component } from 'react';
import copy from 'clipboard-copy';
import { Container } from 'react-bootstrap';
import HeaderLocation from '../components/Header';
import FilterButtons from '../components/FilterButtons';
import DoneAndFavoriteCards from '../components/DoneAndFavoriteCards';

class ReceitasFeitas extends Component {
  constructor() {
    super();
    this.state = {
      recipes: [
        {
          id: '52771',
          type: 'comida',
          area: 'Italian',
          category: 'Vegetarian',
          alcoholicOrNot: '',
          name: 'Spicy Arrabiata Penne',
          image: 'https://www.themealdb.com/images/media/meals/ustsqw1468250014.jpg',
          doneDate: '23/06/2020',
          tags: ['Pasta', 'Curry'],
        },
        {
          id: '178319',
          type: 'bebida',
          area: '',
          category: 'Cocktail',
          alcoholicOrNot: 'Alcoholic',
          name: 'Aquamarine',
          image: 'https://www.thecocktaildb.com/images/media/drink/zvsre31572902738.jpg',
          doneDate: '23/06/2020',
          tags: [],
        },
      ],
      filter: 'all',
      displayShareMesage: false,
    };
    this.share = this.share.bind(this);
    this.changeFilter = this.changeFilter.bind(this);
  }

  changeFilter(type) {
    return this.setState({ filter: type });
  }

  share(obj) {
    const location = `http://localhost:3000/${obj.type}s/${obj.id}`;
    copy(location);
    const SHOW_TIME_MILISECONDS = 3000;
    this.setState({ displayShareMesage: true }, () => {
      setTimeout(() => this.setState(
        { displayShareMesage: false },
      ), SHOW_TIME_MILISECONDS);
    });
  }

  render() {
    const { displayShareMesage, recipes, filter } = this.state;
    return (
      <div className="page-wrapper-custom">
        <HeaderLocation title="Receitas Feitas" />
        <Container>
          <div className="text-center mt-4">
            <h2 style={{ fontFamily: 'var(--font-display)', fontWeight: 800, fontSize: '2rem', color: 'var(--color-text)' }}>
              🎉 Histórico de Delícias
            </h2>
            <p style={{ color: 'var(--color-text-muted)', fontSize: '0.95rem' }}>
              Reveja e compartilhe suas conquistas culinárias e coquetéis preparados.
            </p>
          </div>

          <FilterButtons changeFilter={ this.changeFilter } />
          
          { displayShareMesage && (
            <div className="share-toast mx-auto my-3" role="status" aria-live="polite">
              ✨ Link copiado para a área de transferência!
            </div>
          )}

          <DoneAndFavoriteCards
            recipes={ recipes }
            filter={ filter }
            share={ this.share }
          />
        </Container>
      </div>
    );
  }
}

export default ReceitasFeitas;
